import { render, staticRenderFns } from "./presentation-location.vue?vue&type=template&id=79a94a60&"
import script from "./presentation-location.vue?vue&type=script&lang=js&"
export * from "./presentation-location.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports